(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-prefilters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  
    const currentURL = window.location.href;
    const prefilters = document.querySelectorAll('.filter-block');
    //console.log('currentURL', currentURL)
    prefilters.forEach(prefilter => {
        if (prefilter.querySelector('a')) {
          const prefilterURL = prefilter.querySelector('a').href;
          //console.log('prefilterURL', prefilterURL)
          if (prefilterURL === currentURL) {
              prefilter.classList.add('is-current');
          }
        }
    });

  document.querySelectorAll('modal-opener').forEach(opener => {
  opener.addEventListener('click', () => {
    
    const modalId = opener.getAttribute('data-modal');
    const modal = document.querySelector(modalId);

    if (modal) {
      modal.setAttribute('open', '');  
      document.body.classList.add('overflow-hidden');
    }
  });
});

// Gestion de la fermeture du modal
document.querySelectorAll('.product-popup-modal__toggle').forEach(closeButton => {
  closeButton.addEventListener('click', (event) => {
    const modal = event.target.closest('modal-dialog');
    if (modal) {
      modal.removeAttribute('open');  // Suppression de la propriété open
      document.body.classList.remove('overflow-hidden'); // Réactive le scroll
    }
  });
});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperRecos = new Swiper('.product-recommendations--loaded .swiper', {
                loop: true,
                slidesPerView: 2,
                centeredSlides: true,
                roundLengths: true,
                spaceBetween: 10,
                grabCursor: true,
                mousewheel: {
                  releaseOnEdges: true,
                },
                navigation: {
                  nextEl: '.swiper-recos-next',
                  prevEl: '.swiper-recos-prev',
                },
                breakpoints: {
                  750: {
                    initialSlide: 1,
                    slidesPerView: 3,
                    spaceBetween: 15,
                    centeredSlides: false
                  },
                  990: {
                    initialSlide: 1,
                    slidesPerView: 4,
                    spaceBetween: 20,
                    centeredSlides: false
                  }
                }
              })
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timer_counter"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
  const timerElement = document.querySelector(".countdown-timer");
  const hiddenContent = document.getElementById("hidden-content");
  const targetDateTimeStr = timerElement.getAttribute("data-time");
  const targetDate = new Date(targetDateTimeStr.replace(" ", "T"));

  // Vérifier si la date est valide
  if (isNaN(targetDate.getTime())) {
    console.error("Date cible invalide");
    timerElement.innerHTML = "Date invalide.";
    return;
  }

  // Fonction de mise à jour du compte à rebours
  function updateCountdown() {
    const now = new Date().getTime();
    const timeLeft = targetDate.getTime() - now;

    if (timeLeft <= 0) {
      // Masquer le timer
      timerElement.style.display = "none";

      // Afficher le contenu masqué lorsque le timer atteint 0
      if (hiddenContent) {
        hiddenContent.classList.add("visible");
      } else {
        console.error("L'élément hidden-content n'existe pas !");
      }
      return;
    }

    // Calculer les jours, heures, minutes et secondes restants
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Mettre à jour les valeurs du DOM
    document.getElementById("days").textContent = days.toString().padStart(2, '0');
    document.getElementById("hours").textContent = hours.toString().padStart(2, '0');
    document.getElementById("minutes").textContent = minutes.toString().padStart(2, '0');
    document.getElementById("seconds").textContent = seconds.toString().padStart(2, '0');
  }

  // Mettre à jour le compte à rebours toutes les secondes
  setInterval(updateCountdown, 1000);
  updateCountdown();
});


  } catch(e) { console.error(e); }
})();
})();
